export default import.meta.ROLLDOWN_FILE_URL_UxAIr03ohgrruZoRR5cLDg